<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <yi_upload v-if="$attrs.action == 'xinzeng' || $attrs.action == 'bianji'" ref="upload" :isShowFiles="false"
      :accept="'image/png, image/jpeg,image/gif,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel'"
      :ids.sync="fileIds" :limit="5">
      <div slot="limitMsg"></div>
    </yi_upload>
    <!-- table表格 -->
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column  prop="name" :label="$t('wendangmingcheng')">
      </el-table-column>
      <el-table-column prop="nickname" :label="$t('chuangjianren')" width="250">
      </el-table-column>
      <el-table-column prop="createTime" :label="$t('chuangjianshijian')" width="250">
        <template slot-scope="scope">
          {{dayjs(createTime).format('YYYY-MM-DD HH:mm:ss')}}
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作" width="200">
        <template slot-scope="scope">
          <!-- <el-button v-if="$attrs.action == 'chakan'" :loading="scope.row.loading" @click="downFile(scope.row)" type="text">{{ $t('yulan') }}</el-button> -->
          <el-button v-if="$attrs.action == 'chakan'" :loading="scope.row.loading" @click="downFile(scope.row)" type="text">{{ $t('xiazai') }}</el-button>
          <el-button type="text" class="font-color-danger"
            v-if="$attrs.action == 'xinzeng' || $attrs.action == 'bianji'"
            @click="handleDelete(scope.$index, scope.row)">{{ $t('shanchu') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script type="text/javascript">
// import importExcel from './import_excel'
export default {
  name: 'web_quality_management_standard_doc_standard_appendix',
  components: {
    // importExcel
  },
  data() {
    return {
      tableData: [],
      fileIds: [],
      desc: null,
      planCodeList: [],
      show: false,
      exceptionTypeList: []
    };
  },
  watch: {
    'fileIds': {
      handler(n) {
        if (n) {
          if( this.$attrs.action == 'xinzeng'){
            this.tableData = []
          }
          
          console.log("文件变化", this.$refs.upload.fileList)
          for (let i = 0; i < this.$refs.upload.fileList.length; i++) {

            let item = this.$refs.upload.fileList[i]

            let k = 0
            for(let j=0;j<this.tableData.length;j++){
              if(this.tableData[j].id == item.id){
                k = 1;
              }
            }
            if(k == 1){
              continue
            }
            this.tableData.push({
              createTime: item.createTime,
              name: item.name,
              nickname: item.createByObject.nickname,
              fileInfoId: item.id,
              key: item.key,
              id: item.id
            })
          }
          console.log("table", this.tableData)

        }
      },
      immediate: false,
      deep: true
    }
  },
  created() {

    setTimeout(() => {
      console.log("this.$attrs.appendix", this.$attrs.appendix)
      let files = this.$attrs.appendix.inOrderFiles
      console.log("yt.files", files)
      if (files) {
        // this.tableData = []
        for (let i = 0; i < files.length; i++) {
          this.tableData.push({
            createTime: files[i].createTime,
            name: files[i].fileName,
            nickname: files[i].nickname,
            fileInfoId: files[i].fileInfoId,
            key: files[i].key,
            id:files[i].fileInfoId
          })
        }
        console.log("table", this.tableData)
      }
    }, 300)

  },
  mounted() {
    // if(this.$attrs.appendix.basicWorkProcedure){
    //   this.desc = this.$attrs.appendix.basicWorkProcedure.desc
    // }else {
    //   this.desc = ''
    // }
  },
  methods: {
    handleDelete(index, row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tableData.splice(index, 1);
        this.$refs.upload.fileList.splice(index, 1);
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

      console.log(index, row);
    },
    // 下载文件
    downFile(row) {
      this.$set(row, 'loading', true);
      this.http.get('/web/customer/files/download?id=' + row.fileInfoId).then(res => {
        let baseUrl = res.data;
        this.$set(row, 'loading', false);
        if (res.data) {
          window.open(baseUrl);
        }
      }).catch(err => {
        this.$set(row, 'loading', false);
      });
    }
  }
};
</script>
